/* eslint eqeqeq: ["error", "always", { "null": "ignore" }] */
import * as actions from './actions';
import { combineReducers } from './util';
export function paginationReducer(state, action) {
  switch (action.type) {
    case actions.initPagination.type:
      return {
        ...action.payload,
        ...state
      };
    case actions.goToPage.type:
      return {
        ...state,
        currentPage: action.payload
      };
    case actions.setPageSize.type:
      return {
        ...state,
        currentPage: 0,
        pageSize: action.payload
      };
    case actions.updateFilter.type:
    case actions.resetFilter.type:
    case actions.resetAllFilters.type:
    case actions.setSort.type:
      return {
        ...state,
        currentPage: 0
      };
    default:
      return state;
  }
}
export function filterReducer(state, action) {
  switch (action.type) {
    case actions.registerFilter.type:
      return {
        ...state,
        [action.payload.key]: {
          ...action.payload,
          value: getInitialFilterValue(state, action)
        }
      };
    case actions.updateFilter.type:
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          value: action.payload.value
        }
      };
    case actions.resetFilter.type:
      if (!state[action.payload]) {
        return state;
      }
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          value: state[action.payload].defaultValue
        }
      };
    case actions.resetAllFilters.type:
      return Object.keys(state).reduce((nextState, key) => {
        if (action.payload && action.payload.exceptKey === key) {
          return nextState;
        }
        const filter = nextState[key];
        nextState[key] = {
          ...filter,
          value: filter.defaultValue
        };
        return nextState;
      }, {
        ...state
      });
    default:
      return state;
  }
  function getInitialFilterValue(prevState, action) {
    if (prevState && prevState[action.payload.key]) {
      return prevState[action.payload.key].value;
    }
    return action.payload.value != null ? action.payload.value : action.payload.defaultValue;
  }
}
export function sortReducer(state, action) {
  switch (action.type) {
    case actions.setSort.type:
      return action.payload;
    default:
      return state;
  }
}
export default combineReducers({
  pagination: paginationReducer,
  filter: filterReducer,
  sort: sortReducer
});